import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useState } from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import cn from 'classnames';
import adunitStyles from './adunits.scss';
const DesktopAdhesionGak = /*#__PURE__*/ React.memo(({ safety = 'off', safetyState })=>{
    const [hidden, setHidden] = useState(false);
    const size = {
        width: '970px',
        height: '90px',
        overflow: 'hidden'
    };
    const _useAdUnit = useAdUnit(AdProviders.Taboola, ADUNIT_MAP['DesktopAdhesionGam'], safety, safetyState, {
        mode: 'thumbs-feed-01',
        target_type: 'mix',
        // TODO not supported afaik
        targeting: {
            unitType: 'atf'
        }
    }), { advertIsOff } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(adunitStyles['adhesion'], hidden && adunitStyles['hidden'])
    }, !hidden && /*#__PURE__*/ React.createElement("div", _object_spread({
        style: size
    }, slotAttr)), /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": "Hide Advertisment",
        icon: Close,
        size: 'small',
        onClick: ()=>{
            setHidden(true);
        }
    }));
}, adunitMemo);
DesktopAdhesionGak.displayName = 'DesktopAdhesionGak';
export default DesktopAdhesionGak;
